
<template>
	<div class="me header-padding">
		<f-page-header />

		<el-card shadow="never" class="b-card" v-loading="loading">
			<div class="font-16">{{ god.full_name }}</div>
			<div class="flex c-card line">
				<div class="me-card">
					<span class="text-bold font-2x">{{ user.username }}</span>
					<i class="el-icon-user-solid font-lg ml-sm" :class="user.gender == 1 ? 'text-blue' : 'text-danger'"></i>
					<!-- <span>{{ '工号： ' + user.worker_no }}</span> -->
					<div class="mt-sm">
						<span v-if="user.worker_no" class="mr-lg">{{ '工号：' + user.worker_no }}</span>
						<span v-if="user.role">{{ user.role.title }}</span>
					</div>
				</div>
				<div class="image-editor">
					<!-- <el-avatar :size="100" :src="false" class="bg-trans" fit="contain"> -->
					<!-- <img src="@/assets/logo.png" /> -->
					<f-user-avatar size="huge" :user="user"></f-user-avatar>
					<!-- </el-avatar> -->
					<div class="mask flex-center" @click="logoUploaderShow = true">修改</div>
				</div>
			</div>
			<div class="me-item text-muted line">
				<div>
					<div class="mb-sm">手机号</div>
					<span class="number text-black">{{ user.mobile || '未设置' }}</span>
					<span>（如需修改，请到小程序端重新授权或联系管理员）</span>
				</div>
			</div>
			<div class="me-item text-muted line">
				<div>
					<div>邮箱</div>
					<div class="text-black mt">{{ user.email || '未设置' }}</div>
				</div>
				<el-button class="btn" type="text" @click="editorE">{{ user.email ? '修改' : '设置' }}</el-button>
			</div>
			<div class="me-item text-muted line">
				<div>
					<div>密码</div>
					<div class="mt-sm">
						<span class="text-black">已设置</span>
						<i class="el-icon-circle-check text-success font-lg ml-sm"></i>
					</div>
				</div>
				<el-button class="btn" type="text" @click="passwordDialogShow = true">修改</el-button>
			</div>
		</el-card>
		<f-image-cropper v-model="logoUploaderShow" @crop-upload-success="logoUploadSuccess" />
		<f-password-modify :show.sync="passwordDialogShow" />
	</div>
</template>

<script>
export default {
	name: "Me",
	components: {
		FPasswordModify: () => import("./components/FPasswordModify")
	},
	data () {
		return {
			loading: false,
			// user: {},
			// god: {},
			logoUploaderShow: false,
			passwordDialogShow: false,
			uploadUrl: process.env.VUE_APP_API_HOST + "?c=utility&a=file&do=upload"
		};
	},
	computed: {
		user () {
			return this.$store.state.userStore.user;
		},
		god () {
			return this.$store.state.godStore.god;
		}
	},
	created () {
		// this.fetchData()
	},
	methods: {
		fetchData () {
			this.loading = true;
			this.$store.dispatch("getUserInfoAction").then(res => {
				if (!res.errno) {
					this.user = res.data.user;
					this.god = res.data.god;
					this.loading = false;
				} else {
					this.$message.error(res.message);
				}
			});
		},

		editorE () {
			this.$prompt("请输入新邮箱", "修改邮箱", {
				closeOnClickModal: false,
				inputPattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
				inputErrorMessage: "请填写正确有效的邮箱地址",
				inputValue: this.user.email,
				inputPlaceholder: "请填写正确有效的邮箱地址"
			})
				.then(({ value }) => {
					this.$store
						.dispatch("setUserInfoAction", { email: value })
						.then(res => {
							if (!res.errno) {
								this.$message.success("个人信息修改成功");
							} else {
								this.$message.error(res.message);
							}
						});
				})
				.catch(() => {
					// 取消
				});
		},
		logoUploadSuccess (res) {
			this.$store
				.dispatch("setUserInfoAction", { avatar: res.data.url })
				// editorMeApi(this.user)
				.then(res => {
					if (!res.errno) {
						this.$message.success("个人信息修改成功");
						// this.fetchData()
					} else {
						this.$message.error(res.message);
					}
				})
				.catch(() => { });
		}
	}
};
</script>

<style lang="scss" scoped>
.me {
	position: relative;
	.b-card {
		width: 1180px;
		padding: 30px 100px;
		margin: 0px auto;
		.c-card {
			justify-content: space-between;
			padding: 20px 0px;
			.image-editor {
				width: 100px;
				height: 100px;
				position: relative;
				.avatar-size {
					width: 100px;
					height: 100px;
					border-radius: 50%;
				}
				.mask {
					position: absolute;
					width: 100%;
					height: 100%;
					left: 0;
					top: 0;
					border-radius: 50%;
					cursor: pointer;
					color: #f9f9f9;
					background-color: rgba(0, 0, 0, 0.5);
					opacity: 0;
					transition: opacity 0.3s;
					&:hover {
						opacity: 1;
					}
				}
			}
			.me-card {
				width: 500px;
				padding-top: 52px;
			}
		}
		.me-item {
			position: relative;
			padding: 15px 0px;
			display: flex;
		}
		.line {
			width: 100%;
			border-bottom: 1px solid #ebeef5;
		}
		.btn {
			position: absolute;
			right: 0px;
			bottom: 0px;
		}
	}
}
</style>
